import _slicedToArray from '../../../../node_modules/@babel/runtime/helpers/slicedToArray.es.js';
import { gridDimensions } from '@mgmresorts/wcl-styled';
import React from 'react';

var VIEWPORT_CONTEXT_INITIAL_WINDOW_WIDTH = 1440;
function buildViewportContextValue(viewport) {
  return {
    type: viewport,
    sm: viewport === 'sm',
    md: viewport === 'md',
    lg: viewport === 'lg',
    xl: viewport === 'xl',
    minMd: ['md', 'lg', 'xl'].includes(viewport),
    minLg: ['lg', 'xl'].includes(viewport),
    minXl: ['xl'].includes(viewport),
    maxSm: ['sm'].includes(viewport),
    maxMd: ['sm', 'md'].includes(viewport),
    maxLg: ['sm', 'md', 'lg'].includes(viewport)
  };
}
function calculateViewportContextValue(_ref) {
  var windowWidth = _ref.windowWidth;
  var viewport = Object.entries(gridDimensions).find(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        grid = _ref3[1];

    return windowWidth >= grid.minScreenWidth && windowWidth <= grid.maxScreenWidth;
  })[0];
  return buildViewportContextValue(viewport);
} // Desktop as the default value

var ViewportContext = /*#__PURE__*/React.createContext(calculateViewportContextValue({
  windowWidth: VIEWPORT_CONTEXT_INITIAL_WINDOW_WIDTH
}));

export { VIEWPORT_CONTEXT_INITIAL_WINDOW_WIDTH, ViewportContext, buildViewportContextValue, calculateViewportContextValue };
